import React, {useState, useEffect} from 'react';
import './Background.css';


const Checkbox = ({color, id}) => {
	return(
		<div className='background-color-option'>
			<svg width='25px' height='25px'>
				<rect id={color}  width='50px' height='50px' fill={color} />
			</svg>
		</div>

		)
}

const Background = () => {

	const [color, setState] = useState()

	async function handleBackgroundSelection(e) {
		console.log(e.target.id)
		if(e.target.id !== e.currentTarget) {
			setState(e.target.id)
		}
		
	}

	useEffect(() => {document.querySelector('.App').style.background = color}, [color])

	return (
		<div className='backgrounds-settings right-side-body'>
			<div className='options-heading'>
				<h1>Backgrounds</h1>
				<p>Choose your scenery</p>
			</div>
			<div className='backgrounds-color'>
				<h4 className='settings-sub-heading'>Background Colors</h4>
				<div className='background-color-selection-container' onClick={handleBackgroundSelection}>
					<div id='' className='background-color-option'>
						<svg width='25px' height='25px'>
							<rect width='50px' height='50px' fill='white' />
							<line x1="0" y1="0" x2="25" y2="25" stroke="black" strokeWidth="2" />
   							<line x1="25" y1="0" x2="0" y2="25" stroke="black" strokeWidth="2" />
						</svg>
					</div>
					<Checkbox id='purple' color='#3B1542' />
					<Checkbox id='blue' color='#1F6A8F'/>
					<Checkbox id='green' color='#228F6C'/>
					<Checkbox id='orange' color='#8F481B'/>
				</div>
			</div>
		</div>	
		)
}

export default Background;